import { motion } from 'framer-motion';

export default function FollowUs() {
  return (
    <section className="py-20 md:py-28 bg-gray-50 border-y border-gray-100">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <p className="section-label">Stay Connected</p>
          <h2 className="mt-3 section-heading">Follow our journey on LinkedIn</h2>
          <p className="mt-4 section-sub max-w-xl mx-auto">
            What we're shipping, what we're learning, and the occasional behind-the-scenes
            from the team — we post there first.
          </p>
          <a
            href="https://www.linkedin.com/company/pulse-stack/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2.5 px-6 py-3.5 rounded-xl bg-[#0A66C2] text-white font-semibold hover:bg-[#0958a8] transition-colors shadow-sm"
          >
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
            Follow PulseStack AI on LinkedIn →
          </a>
        </motion.div>
      </div>
    </section>
  );
}
